/**
 * Async AdSense Banners via Javascript
 * 
 * https://github.com/Zaifor/AddSense.js
 */
!function(t,e){"use strict";var i="block",o="px",r="google_persistent_state_async",a="adsbygoogle",s="data-ad-client",n="data-ad-slot",d="data-override-format",c="data-page-url",l="data-language",p=function(t){function r(t){var r=e.createElement("ins");return r.className=a,r.style.display=i,r.style.width=t.width+o,r.style.height=t.height+o,r.setAttribute(s,t.client),r.setAttribute(n,t.slot),void 0!==t.overrideFormat&&r.setAttribute(d,t.overrideFormat),void 0!==t.pageUrl&&r.setAttribute(c,t.pageUrl),void 0!==t.language&&r.setAttribute(l,t.language),r}this.html=r(t),this.container=e.querySelectorAll(t.container)[0]};p.prototype={constructor:p,render:function(){this.container.appendChild(this.html),(t.adsbygoogle=t.adsbygoogle||[]).push({}),delete t[r]}};var u=function(){this.script="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js",this.isScriptLoaded=!1};u.prototype={constructor:u,loaded:function(){if(this.isScriptLoaded)return this.isScriptLoaded;for(var i=0;i<e.scripts.length;i++)e.scripts[i].src===t.location.protocol+this.script&&(this.isScriptLoaded=!0);return this.isScriptLoaded},load:function(){var t=e.createElement("script");t.src=this.script,e.body.appendChild(t)},unit:function(t){return this.loaded()||this.load(),new p(t)}},t.AddSense=new u}(window,document);

var ViewAd = function(gal){
	var _this = this;

	/* Event eventualy fired by sliderClass.js or uiClass.js */
	// window.addEventListener('ad.wrapper.ready', _loadAdAtPage, true);

	var adHasShown = false;
	var adIsVisible = false;
	//if redirected, then ad has already been shown
	if(helpers.urlHasRedirectParam(location.href)){
		adHasShown = true;
	}else{
		window.addEventListener('ad.wrapper.ready', _loadSaSad, true);

	}

	function _removeSaSad(direction){
		var catalog = slider.getCatalog();
		var adSlide = dom.getById("ad-slide");

		if(adSlide){
			dom.remove(adSlide);
		}else{
			return;
		}

		var slides = dom.getAll('.slide');
		dom.removeClass(slides[0], "slide-ad-back");
		dom.removeClass(slides[1], "slide-ad-back");
		dom.removeClass(slides[2], "slide-ad-back");
		adIsVisible = false;

		window.removeEventListener('ad.wrapper.ready', _loadSaSad, true);

		if(_adLayerIndex){
			//remove ad layer from slides array
			catalog.doubleContent.layers.splice(_adLayerIndex.double, 1);
			catalog.singleContent.layers.splice(_adLayerIndex.single, 1);
			
			var inx = {single: 0, double: 0};

			switch(true){
				case direction == "next":
					inx.double = _adLayerIndex.double - 1;
					inx.single = _adLayerIndex.single - 1;
				break;
				case direction == undefined:
				case direction == "prev":
					inx.double = _adLayerIndex.double;
					inx.single = _adLayerIndex.single;
				break;
				case direction == "to":
					inx.double = catalog.doubleContent.layers.length - 1;
					inx.single = catalog.singleContent.layers.length - 1; 
				break;
			}

			_adLayerIndex = null;
			//reinit slides because they mess-up after removing ad slide
			if(catalog.isDoubleMode()){
				catalog.doubleContent.currentLayer = inx.double;
				//update hash after ad is removed
				catalog.setLayer(catalog.doubleContent.currentLayer);
				slider.switchToDoubleMode();
			}else{
				catalog.singleContent.currentLayer = inx.single;
				catalog.setLayer(catalog.singleContent.currentLayer);
				slider.switchToSingleMode();
			}
		}
	}

	/**
	 * Loads ad in the middle of the catalog view
	 */

	function _loadSaSad(event){

		/*new code for SaS and Criteo*/
		
		if(typeof middlePageAdSas !== 'undefined' && middlePageAdSas.siteId && middlePageAdSas.pageId && middlePageAdSas.formatId){
			var siteId = middlePageAdSas.siteId;
			var pageId = middlePageAdSas.pageId;
			var formatId = middlePageAdSas.formatId;
		}else{
			return;
		}

		var adContainer = event.customMessage.container;
		var targetFormatId = 'sas_' + middlePageAdSas.formatId;
		var targetFormatWrapper = document.createElement("div");
		var adNextPage = dom.getById("ad-text-subtitle");
		var adLoader = document.createElement("div");

		targetFormatWrapper.id = targetFormatId;
		targetFormatWrapper.className = "sas-ad-container";

		adLoader.className = "loader"
		targetFormatWrapper.appendChild(adLoader);
		
		adContainer.appendChild(targetFormatWrapper);
		adNextPage.addEventListener('click', function(){
			_removeSaSad();

		});

		sas.cmd.push(function() {
			sas.call("std", {
				siteId:		siteId,
				pageId:		pageId,
				formatId: 	formatId,
				target:		targetFormatId
			}, {	
					onLoad: function(e){
						// console.log("eventObj: ", e);
						if (!e.hasAd) {
							setTimeout(_removeSaSad, 200);
						}else{
							dom.getById(e.tagId).style.display = "block";
							adHasShown = true;
							adIsVisible = true;
						}
					},
					onError: function(е){
						// console.log("error: ", е);
					},
					beforeRender: function(data){
						// console.log("beforeRender2: ", data);
					},
					onClean: function(data, test, test2){
						// console.log("onClean: ", data, test, test2);
					}
				}
			)
		});

		sas.render();
	}

	function _loadAdAtPage(event)
	{
		var adContainer = event.customMessage.container;

		adContainer.innerHTML = "";

		var client, slot;
		if (middlePageAdProps.client && middlePageAdProps.slot) {
			client = middlePageAdProps.client;
			slot = middlePageAdProps.slot;
		}else{
			return;

			/* Testing credentials */
			client = "ca-pub-5253572846890743";
			slot = "4704806711";
		}

		/* Create and Add AdSense Ad Unit */
		AddSense.unit({
	        container : "#ad-unit",
	        client : client,
	        slot : slot,
	        width : 336,
	        height : 280,
	        overrideFormat : "true",
	        pageUrl : window.location.protocol + '//' + window.location.hostname
	    }).render();
	}


	/* Old Script replaced by _loadAdAtPage */

	adLoaded = false;

	function _loadNewAdIntheView(event) {

		var adWrapper = event.customMessage.wrapper;

		var adClassName = 'ad_unit';
		
		if (adLoaded===true) {
			adWrapper.innerHTML = "";
			adWrapper.innerHTML = adUnitCache;

			return;
		};

		if(!middlePageAdProps)
			return;

		if (!middlePageAdProps.client) {
			return;
		};

		if (!middlePageAdProps.slot) {
			return;
		};

		window.google_ad_client = middlePageAdProps.client;
		window.google_ad_slot = middlePageAdProps.slot;
		window.google_ad_width = middlePageAdProps.width;
		window.google_ad_height = middlePageAdProps.height;

		// Else

		adUnit = document.createElement("ins");
		adUnit.style.display = 'block';
		adUnit.style.width = '300px';
		adUnit.style.height = '250px';
		adUnit.className = adClassName;

		adWrapper.appendChild(adUnit);

		var w = document.write;
		document.write = function (content) {
		    adUnit.innerHTML = content;
		    document.write = w;
		};
		
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.onload = function() {
			adUnitCache = adWrapper.innerHTML;
		}
		script.src = 'http://pagead2.googlesyndication.com/pagead/show_ads.js';

		adWrapper.appendChild(script);
		adLoaded = true;
	}

	/**
	 * Loading ad in the front page/cover of the catalog view
	 */

	/* Front Cover Ad */
	window.addEventListener('ui.cover.front.show', _loadAdAtFrontCover, true);

	var frontCoverAdLoaded = false;
	function _loadAdAtFrontCover()
	{
		if (frontCoverAdLoaded===true) { return; };

		/* Fix */

		frontPageAdWrapper = document.querySelectorAll(".view-banner")[0];
		if(typeof frontPageAdWrapper === 'undefined' || banner_type == 2 || banner_type == 3){
			return;
		}

		frontPageAdWrapper.innerHTML = "";

		AddSense.unit({
	        container : ".view-banner",
	        client : frontCoverAdProps.client,
	        slot : frontCoverAdProps.slot,
	        width : frontCoverAdProps.width,
	        height : frontCoverAdProps.height,
	        language: frontCoverAdProps.language,
	        overrideFormat : "true",
	        pageUrl : window.location.protocol + '//' + window.location.hostname
	    }).render();

	    frontCoverAdLoaded = true;

		return;

		/* Old Code */

		var 
		hasClient = frontCoverAdProps.hasOwnProperty("client"),
		hasSlot = frontCoverAdProps.hasOwnProperty("slot"),
		hasWidth = frontCoverAdProps.hasOwnProperty("width"),
		hasHeight = frontCoverAdProps.hasOwnProperty("height");

		if (!(hasClient && hasSlot && hasWidth && hasHeight)) {
			//console.error("frontCoverAdProps Object has missing property!");

			return;
		};

		if (!frontCoverAdProps.client) {
			return;
		};

		if (!frontCoverAdProps.slot) {
			return;
		};

		_setAdProps(frontCoverAdProps);

		var ad = _createAdUnit(frontCoverAdProps.width, frontCoverAdProps.height),
		frontPageAdWrapper = document.querySelectorAll(".view-banner")[0];
		frontPageAdWrapper.appendChild(ad);

		_documentWriteMagic(ad);
		frontPageAdWrapper.appendChild(_buildScript());
		frontCoverAdLoaded = true;
	}

	/* Old code replaced by AddSense.js */

	function _createAdUnit(width, height)
	{
		var 
		adUnit = document.createElement("ins");
		adUnit.style.display = 'block';
		adUnit.style.width = width+'px';
		adUnit.style.height = height+'px';

		return adUnit;
	}

	function _setAdProps(props)
	{
		window.google_ad_client = props.client;
		window.google_ad_slot = props.slot;
		window.google_ad_width = props.width;
		window.google_ad_height = props.height;
	}

	function _documentWriteMagic(adUnit)
	{
		var w = document.write;
		document.write = function (content) {
		    adUnit.innerHTML = content;
		    document.write = w;
		};
	}

	function _buildScript()
	{
		var 
		script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = 'http://pagead2.googlesyndication.com/pagead/show_ads.js';

		return script;
	}

	// _this. = ;
};